<template lang="pug"></template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'RootSocketListener',
  computed: {
    ...mapGetters({
      deviceId: 'getDeviceId',
      authorizationQr: 'getAuthorizationQr'
    })
  },
  channels: {
    SendQrChannel: {
      connected() {
        console.log(
          '%c Connected to SendQrChannel from AutorizationQr',
          'color: deepskyblue'
        )
      },
      received(data) {
        this.handleIncomingData(data)
      }
    }
  },
  mounted() {
    // INFO: THIS HAPPENS ONLY ON COL DEVICES:
    this.$cable.subscribe({
      channel: 'SendQrChannel',
      device_id: `${this.deviceId}`
    })
  },
  methods: {
    handleIncomingData(data) {
      console.log('SendQrChannel data', data)
      this.storeAuthorizationQr(data.authorization_qr)
    },
    storeAuthorizationQr(qr) {
      this.$store.commit('setAuthorizationQr', qr)
    }
  }
}
</script>
